<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
  <fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="'over'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="false">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex items-center h-20 pt-6 px-8">
        <img
          class="w-24"
          src="assets/images/logo/logo-text-on-dark.svg"
          alt="Logo image" />
      </div>
    </ng-container>
  </fuse-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div
  *ngIf="header$ | async as header"
  class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <div
    *ngIf="header?.canvasType !== 'scrum_team_radar'"
    class="relative flex flex-row justify-between flex-0 items-center w-full h-16 sm:h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <ng-container *ngIf="!isScreenSmall">
      <!-- Logo -->
      <div class="flex items-center mx-2 lg:mr-8">
        <div class="flex flex-row justify-center items-center gap-x-4">
          <button mat-icon-button (click)="goBack()">
            <mat-icon
              svgIcon="heroicons_outline:arrow-left"
              class="cursor-pointer"></mat-icon>
          </button>
          <h1 class="text-gray-900 text-base font-semibold leading-7">
            {{ header?.name }}
          </h1>
          <button
            (click)="openBoardSettings()"
            *ngIf="header?.roleTypeName === 'Board'">
            <mat-icon class="flex items-center"
              ><img src="assets/icons/settingsIcon.svg"
            /></mat-icon>
          </button>
          <button
            (click)="openWorkshopSettings()"
            *ngIf="header?.roleTypeName === 'Workshop'">
            <mat-icon class="flex items-center"
              ><img src="assets/icons/settingsIcon.svg"
            /></mat-icon>
          </button>
          <button
            (click)="openActivitySettings()"
            *ngIf="header?.roleTypeName === 'Activity'">
            <mat-icon class="flex items-center"
              ><img src="assets/icons/settingsIcon.svg"
            /></mat-icon>
          </button>
        </div>
      </div>
    </ng-container>
    <!-- Navigation toggle button -->
    <ng-container *ngIf="isScreenSmall">
      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
      </button>
    </ng-container>

    <!-- Workshop Activity workflow -->
    <div
      *ngIf="header?.roleTypeName === 'Activity'"
      class="flex flex-grow w-1/2 justify-center">
      <div
        class="flex flex-col justify-center h-16 mt-2 items-center px-4 font-medium rounded-lg cursor-pointer"
        (click)="updateWorkflow('presentation')"
        [style.backgroundColor]="
          this.header?.workFlowStep === 'presentation'
            ? 'rgb(236 253 245)'
            : 'rgb(255 255 255)'
        "
        matRipple>
        <div class="wizard-icon mb-1">
          <i class="wizard-check ki ki-check"></i>
          <span class="wizard-number">
            <span class="svg-icon svg-icon-3x">
              <svg
                [attr.fill]="
                  this.header?.workFlowStep === 'presentation'
                    ? '#008000'
                    : '#0B132B'
                "
                width="30px"
                height="30px"
                viewBox="0 0 20 20"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g
                  id="Icon-present"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd">
                  <path
                    d="M12.6463651,17.9998703 C12.7035549,17.9998703 12.7827173,17.9670335 12.8230919,17.9265367 L13.1765457,17.5721369 C13.2740186,17.4743283 13.2740186,17.3155763 13.1765457,17.2177677 L10.4999774,14.5337226 L10.4999774,12.9984174 L16.9999619,12.9984174 C17.5518404,12.9984174 17.9999595,12.5484062 17.9999595,11.9956122 L17.9999595,3.00280523 L18.7499577,3.00280523 C18.8880799,3.00280523 18.9999571,2.89062288 18.9999571,2.75219547 L18.9999571,2.25060975 C18.9999571,2.11218235 18.8880799,2 18.7499577,2 L1.2499994,2 C1.11187717,2 1,2.11218235 1,2.25060975 L1,2.75185978 C1,2.8903177 1.11187717,3.00250005 1.2499994,3.00250005 L2,3.00250005 L2,11.9956122 C2,12.5484062 2.44811666,12.9984174 3,12.9984174 L9.49997973,12.9984174 L9.49997973,14.5337226 L6.82310623,17.2177677 C6.7256028,17.3155763 6.7256028,17.4743283 6.82310623,17.5721369 L7.17655998,17.9265367 C7.21690412,17.9670335 7.29609705,17.9998703 7.35325634,17.9998703 C7.41044614,17.9998703 7.48960855,17.9670335 7.52998321,17.9265367 L9.99997854,15.4502853 L12.4696687,17.9265367 C12.5100434,17.9670335 12.5892058,17.9998703 12.6463651,17.9998703 Z M16.9999619,11.9999762 L2.99999523,11.9999762 L2.99999523,2.99999762 L16.9999619,2.99999762 L16.9999619,11.9999762 Z"
                    id=""
                    fill="#0B132B"
                    fill-rule="nonzero"></path>
                </g>
              </svg>
            </span>
          </span>
        </div>
        <div class="flex flex-col items-center">
          <div
            class="leading-5 select-none text-center"
            [style.color]="
              this.header?.workFlowStep === 'presentation'
                ? 'rgb(52 211 153)'
                : 'rgb(0 0 0)'
            ">
            Present
          </div>
        </div>
      </div>
      <div class="w-8 ml-2 mt-5">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </div>

      <div
        class="flex flex-col justify-center h-16 mt-2 items-center px-4 font-medium rounded-lg cursor-pointer"
        [style.backgroundColor]="
          this.header?.workFlowStep === 'brainstorm'
            ? 'rgb(236 253 245)'
            : 'rgb(255 255 255)'
        "
        (click)="showStartBrainstormDialog()"
        matRipple>
        <div class="wizard-icon mb-1">
          <i class="wizard-check ki ki-check"></i>
          <span class="wizard-number">
            <span class="wizard-number svg-icon svg-icon-3x">
              <svg
                width="30px"
                height="30px"
                viewBox="0 0 20 20"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g
                  id="Icon-bulb"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd">
                  <path
                    d="M11.7318611,17.9999619 C11.8993717,17.9999619 12.0556213,17.9162218 12.1481199,17.7768484 L12.9140482,16.6255755 C12.9684304,16.5437275 12.9974831,16.4474753 12.9977883,16.349331 L12.9999855,13.9999714 C13.070603,13.5087311 13.8434284,12.0252752 14.6387451,11.1181118 C15.485911,10.1515309 15.9999784,8.88654974 15.9999784,7.49998689 C15.9999784,4.46248803 13.5374904,2 10.5,2 C7.28280557,2 4.99625096,4.61062 5,7.50749419 C5.00186618,8.89121892 5.51562839,10.1534229 6.36123794,11.1181118 C7.16281074,12.0321721 7.93279792,13.5212128 8,13.9999714 L8.00185903,16.349331 C8.00185903,16.4477805 8.03124739,16.5437275 8.08562958,16.6255755 L8.85155793,17.7768484 C8.94436167,17.9162218 9.10061129,17.9999619 9.26781671,17.9999619 L11.7318611,17.9999619 Z M12.3062311,12.9996686 L8.69405709,12.9996686 C8.24844047,11.9615241 7.5506272,10.9574677 7.11343341,10.4587201 C6.3906263,9.63435069 6.00406106,8.58903458 6.00154616,7.49998689 C5.9959434,5.0940478 7.88842546,2.99999762 10.4999915,2.99999762 C12.9812478,2.99999762 14.9999808,5.0187306 14.9999808,7.49998689 C14.9999808,8.58903458 14.604657,9.63999643 13.8868548,10.4587201 C13.449661,10.9574677 12.7515425,11.9618598 12.3062311,12.9996686 Z M7.49999985,7.99999523 C7.77624311,7.99999523 7.99999985,7.77623135 7.99999985,7.49999523 C7.99999985,6.12154169 9.12124113,4.99999523 10.4999998,4.99999523 C10.776236,4.99999523 10.9999998,4.7762385 10.9999998,4.49999523 C10.9999998,4.22374958 10.776236,3.99999523 10.4999998,3.99999523 C8.5703086,3.99999523 6.99999985,5.57030399 6.99999985,7.49999523 C6.99999985,7.77623135 7.2237542,7.99999523 7.49999985,7.99999523 Z M11.9993776,14.9999702 L9.00030025,14.9999702 L8.99813351,13.9999702 L12.0005983,13.9999702 L11.9993776,14.9999702 Z M11.4640395,16.9999654 L9.53560781,16.9999654 L9.00155147,16.1971402 L9.0012463,15.9999654 L11.9981264,15.9999654 L11.9981264,16.1971402 L11.4640395,16.9999654 Z"
                    id=""
                    fill="#0B132B"
                    fill-rule="nonzero"></path>
                </g>
              </svg>
            </span>
          </span>
        </div>
        <div class="flex flex-col items-center">
          <div
            class="leading-5 select-none text-center"
            [style.color]="
              this.header?.workFlowStep === 'brainstorm'
                ? 'rgb(52 211 153)'
                : 'rgb(0 0 0)'
            ">
            Brainstorm
          </div>
        </div>
      </div>
      <div class="w-8 ml-2 mt-5">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </div>

      <div
        class="flex flex-col justify-center h-16 mt-2 items-center px-6 font-medium rounded-lg cursor-pointer"
        [style.backgroundColor]="
          this.header?.workFlowStep === 'vote'
            ? 'rgb(236 253 245)'
            : 'rgb(255 255 255)'
        "
        (click)="showStartVotesDialog()"
        matRipple>
        <div class="wizard-icon mb-1">
          <i class="wizard-check ki ki-check"></i>
          <span class="wizard-number svg-icon svg-icon-3x pulse pulse-primary">
            <svg
              width="30px"
              height="30px"
              viewBox="0 0 20 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <g
                id="Icon-vote"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd">
                <path
                  d="M18.9999547,16.9999666 C19.5530845,16.9999666 19.9999523,16.5530988 19.9999523,15.999969 L19.9999523,11.9999785 C19.9999523,11.4468488 19.5530845,10.9999809 18.9999547,10.9999809 L16.9999595,10.9999809 L16.9999595,3.95312273 C16.9999595,3.42813008 16.5530916,3 15.9999619,3 L4,3 C3.44686068,3 3,3.42813008 3,3.95312273 L3,10.9999809 L1,10.9999809 C0.446867831,10.9999809 0,11.4468488 0,11.9999785 L0,15.999969 C0,16.5530988 0.446867831,16.9999666 1,16.9999666 L18.9999547,16.9999666 Z M15.9999619,13.499975 L3.99999046,13.499975 L3.99999046,3.99999762 L15.9999619,3.99999762 L15.9999619,13.499975 Z M9.07810336,10.9968681 C9.14371599,10.9968681 9.20621584,10.9718438 9.25623403,10.9249689 L13.1468498,7.03435317 C13.2437123,6.93749061 13.2437123,6.7781282 13.1468498,6.68123512 L12.7905884,6.33122985 C12.7406007,6.28124218 12.6781009,6.25936113 12.6124577,6.25936113 C12.5499579,6.25936113 12.4843452,6.28435496 12.4343576,6.33122985 L9.07810336,9.69059684 L7.56248197,8.17186267 C7.5124943,8.121875 7.44999444,8.09999394 7.38435129,8.09999394 C7.32185144,8.09999394 7.2562388,8.12498778 7.20622061,8.17186267 L6.85310256,8.52498072 C6.75624,8.6218738 6.75624,8.78123622 6.85310256,8.87809878 L8.89997268,10.9249689 C8.94999087,10.9749871 9.01249072,10.9968681 9.07810336,10.9968681 Z M18.9999547,15.9999785 L0.999997616,15.9999785 L0.999997616,11.9999785 L2.99999762,11.9999785 L2.99999762,13.4999785 L2.29998231,13.4999785 C2.13436381,13.4999785 1.99999762,13.6124625 1.99999762,13.7499744 L1.99999762,14.2499732 C1.99999762,14.3874851 2.13436381,14.4999785 2.29998231,14.4999785 L17.69997,14.4999785 C17.8655885,14.4999785 17.9999571,14.3874851 17.9999571,14.2499732 L17.9999571,13.7499744 C17.9999571,13.6124625 17.8655885,13.4999785 17.69997,13.4999785 L16.9999595,13.4999785 L16.9999595,11.9999785 L18.9999547,11.9999785 L18.9999547,15.9999785 Z"
                  id=""
                  fill="#0B132B"
                  fill-rule="nonzero"></path>
              </g>
            </svg>
          </span>
        </div>
        <div class="flex flex-col items-center">
          <div
            class="leading-5 select-none text-center"
            [style.color]="
              this.header?.workFlowStep === 'vote'
                ? 'rgb(52 211 153)'
                : 'rgb(0 0 0)'
            ">
            Vote
          </div>
        </div>
      </div>
      <div class="w-8 ml-2 mt-5">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </div>

      <div
        class="flex flex-col justify-center h-16 mt-2 items-center px-4 font-medium rounded-lg cursor-pointer"
        (click)="updateWorkflow('next-steps')"
        [style.backgroundColor]="
          this.header?.workFlowStep === 'next-steps'
            ? 'rgb(236 253 245)'
            : 'rgb(255 255 255)'
        "
        matRipple>
        <div class="wizard-icon mb-1">
          <i class="wizard-check ki ki-check"></i>
          <span class="wizard-number svg-icon svg-icon-3x">
            <svg
              width="30px"
              height="30px"
              viewBox="0 0 20 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <g
                id="Icon-task"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd">
                <path
                  d="M4.33827415,6.89140155 L4.34453024,6.88514546 L7.34137978,3.87578374 C7.49137332,3.7257902 7.49137332,3.48827246 7.34452309,3.34142222 L7.11326143,3.11016056 C6.96638068,2.96327981 6.72889345,2.96327981 6.5820127,3.11016056 L4.11952467,5.58516077 L2.91951532,4.38515142 C2.77263457,4.23827067 2.53514734,4.23827067 2.38826659,4.38515142 L2.11016056,4.66328797 C1.96327981,4.81016872 1.96327981,5.04765595 2.11016056,5.1945367 L3.80702542,6.89140155 C3.95390617,7.0382823 4.1913934,7.0382823 4.33827415,6.89140155 Z M17.8163609,5.56327972 C17.9194796,5.56327972 18.0038605,5.47889881 18.0038605,5.37578016 L18.0038605,4.62578195 C18.0038605,4.5226633 17.9194796,4.4382824 17.8163609,4.4382824 L8.19138386,4.4382824 C8.08826521,4.4382824 8.00388431,4.5226633 8.00388431,4.62578195 L8.00388431,5.37578016 C8.00388431,5.47889881 8.08826521,5.56327972 8.19138386,5.56327972 L17.8163609,5.56327972 Z M4.3570119,11.8913896 L4.35075581,11.8851335 L7.36014805,8.87577182 C7.5038855,8.72577828 7.5038855,8.48826054 7.35700474,8.3414103 L7.12577361,8.11014864 C6.97889285,7.96326789 6.74137511,7.96326789 6.59452487,8.11014864 L4.13200633,10.5851488 L2.9320275,9.3851395 C2.78514675,9.23825875 2.54765952,9.23825875 2.40077877,9.3851395 L2.12889831,9.66327604 C1.98201756,9.8101568 1.98201756,10.047644 2.12889831,10.1945248 L3.82576316,11.8913896 C3.97264392,12.0382704 4.21013114,12.0382704 4.3570119,11.8913896 Z M17.8163609,10.5632678 C17.9194796,10.5632678 18.0038605,10.4788869 18.0038605,10.3757682 L18.0038605,9.62577003 C18.0038605,9.52265138 17.9194796,9.43827048 17.8163609,9.43827048 L8.19138386,9.43827048 C8.08826521,9.43827048 8.00388431,9.52265138 8.00388431,9.62577003 L8.00388431,10.3757682 C8.00388431,10.4788869 8.08826521,10.5632678 8.19138386,10.5632678 L17.8163609,10.5632678 Z M4.14140572,16.0007548 C4.76326093,16.0007548 5.25389086,15.4976432 5.25389086,14.8757575 C5.25389086,14.2538718 4.76326093,13.7507602 4.14140572,13.7507602 C3.51952,13.7507602 3.0164084,14.2538718 3.0164084,14.8757575 C3.0164084,15.4976432 3.51952,16.0007548 4.14140572,16.0007548 Z M17.8163609,15.5632559 C17.9194796,15.5632559 18.0038605,15.478875 18.0038605,15.3757563 L18.0038605,14.6257581 C18.0038605,14.5226395 17.9194796,14.4382586 17.8163609,14.4382586 L8.19138386,14.4382586 C8.08826521,14.4382586 8.00388431,14.5226395 8.00388431,14.6257581 L8.00388431,15.3757563 C8.00388431,15.478875 8.08826521,15.5632559 8.19138386,15.5632559 L17.8163609,15.5632559 Z"
                  id=""
                  fill="#0B132B"
                  fill-rule="nonzero"></path>
              </g>
            </svg>
          </span>
        </div>
        <div class="flex flex-col items-center">
          <div
            class="leading-5 select-none text-center"
            [style.color]="
              this.header?.workFlowStep === 'next-steps'
                ? 'rgb(52 211 153)'
                : 'rgb(0 0 0)'
            ">
            Next Step
          </div>
        </div>
      </div>
      <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
        <!-- Add product button -->
        <!-- <button
                    (click)="settingsDrawer.toggle()"
                    aria-labelledby="slide-over-title"
                    role="dialog"
                    aria-modal="true"
                    class="font-medium focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                    mat-flat-button>
                    <mat-icon svgIcon="feather:filter"></mat-icon>
                    <span class="ml-2 mr-1"> Filter</span>
                  </button> -->
      </div>
    </div>

    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <div
        class="flex flex-row gap-x-4 items-center justify-center max-sm:hidden">
        <div
          *ngIf="header.enableCardCost && header.enableCardDuration"
          class="flex flex-row justify-between gap-x-5">
          <div>
            <span class="text-lg mx-2">cost:</span>{{ calculateTotalCost()
            }}{{ header.currency }}
          </div>
          <span>, </span>
          <div>
            <span class="text-lg mx-2">duration:</span
            >{{ calculateTotalDuration() }}{{ header.durationUnit }}
          </div>
        </div>
        <div class="flex -space-x-1 overflow-hidden">
          <div
            *ngFor="let user of header?.users.slice(0, 3)"
            [ngClass]="{
              'bg-orange-300': user.role === 'admin',
              'bg-gray-100': user.role !== 'admin'
            }"
            class="flex items-center justify-center inline-block w-7 h-7 bg-gray-100 rounded-full dark:bg-gray-600 ring-2 ring-white">
            <span
              class="font-medium text-gray-600 dark:text-gray-300"
              *ngIf="!user.image"
              >{{ user.email.substring(0, 2).toUpperCase() }}</span
            >
          </div>
          <div
            [matMenuTriggerFor]="sessionMembersMenu"
            class="flex items-center justify-center cursor-pointer inline-block w-7 h-7 bg-gray-100 rounded-full dark:bg-gray-600 ring-2 ring-white">
            <span
              class="font-medium text-gray-600 dark:text-gray-300 flex items-center justify-center"
              ><mat-icon
                ><img
                  class="w-32 h-32"
                  src="assets/icons/more_users.svg" /></mat-icon
            ></span>
          </div>
          <mat-menu #sessionMembersMenu="matMenu" yPosition="below">
            <button
              mat-menu-item
              style="cursor: default !important; pointer-events: none"
              class="dropdown-item h-35px"
              fxLayout="row"
              fxLayoutAlign="space-between center"
              *ngFor="let user of header?.users">
              <div class="ml-2 navi-text font-size-12">
                {{ user.name ? user.name : user.email }}
              </div>
              <div class="ml-3">
                <span
                  [ngClass]="{
                    'bg-orange-300': user.role === 'admin',
                    'bg-gray-100': user.role !== 'admin'
                  }"
                  class="inline-flex text-white items-center rounded-md px-1.5 py-0.5 text-xs font-medium">
                  {{
                    user.role === 'admin' ? 'Facilitator' : 'Participant'
                  }}</span
                >
              </div>
            </button>
          </mat-menu>
        </div>
        <!-- invite button  -->
        <div
          *ngIf="header$ | async as header"
          class="flex flex-row gap-x-4 items-center justify-center pr-6 border-r">
          <button
            *ngIf="header?.roleTypeName === 'Board'"
            (click)="openBoardInviteSettings()"
            class="btn-secondary-icon-hover">
            <mat-icon
              class="text-black text-sm"
              [svgIcon]="'heroicons_outline:plus'"></mat-icon>
            Invite
          </button>
          <button
            *ngIf="header?.roleTypeName === 'Workshop'"
            (click)="openWorkshopInviteSettings()"
            class="btn-secondary-icon-hover">
            <mat-icon
              class="text-black text-sm"
              [svgIcon]="'heroicons_outline:plus'"></mat-icon>
            Invite
          </button>
          <button
            *ngIf="header?.roleTypeName === 'Activity'"
            (click)="openWorkshopInviteSettings()"
            class="btn-secondary-icon-hover">
            <mat-icon
              class="text-black text-sm"
              [svgIcon]="'heroicons_outline:plus'"></mat-icon>
            Invite
          </button>
        </div>
        <!-- invite button  -->
      </div>
      <search
        *ngIf="header?.roleTypeName !== 'Board'"
        class="max-lg:hidden"
        [appearance]="'bar'"></search>
      <notifications class="max-lg:hidden"></notifications>
      <user [role]="role"></user>
    </div>
  </div>
  <missing-verification-banner
    *ngIf="!isAccountVerified"></missing-verification-banner>
  <div
    *ngIf="
      header?.roleTypeName === 'Activity' &&
      header?.canvasType !== 'scrum_team_radar'
    ">
    <div
      *ngIf="
        this.header?.roleTypeName === 'Activity' &&
        (this.header?.workFlowStep === 'brainstorm' ||
          this.header?.workFlowStep === 'vote')
      ">
      <div class="bg-[#CBE9E7] text-[#00835C] text-center w-full py-1">
        <div
          class="text-[13px] font-medium"
          *ngIf="this.header?.workFlowStep === 'brainstorm'">
          A brainstorm is on! Add your sticky notes under each topic.
        </div>
        <div
          class="text-[13px] font-medium"
          *ngIf="this.header?.workFlowStep === 'vote'">
          A vote is on! You have 2 votes left
        </div>
      </div>
    </div>
  </div>
  <ng-container 
    *ngIf="header?.roleTypeName === 'Board' && header?.value.isTemplate">
    <template-editing-banner></template-editing-banner>
  </ng-container>
  <!-- Content -->
  <div class="flex flex-col flex-auto w-full">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
